<template>
  <div class="body-inner">
    <div class="modal-dim" v-show-modal-alert>
      <!--'on 추가'-->
      <div class="modal-wrap">
        <div class="modal-inner center">
          <div class="modal">
            <div class="modal-con">
              <div class="modal-txt">
                <div class="txt-ttl">{{ title ?? '' }}</div>
                <div class="txt-con">
                  <p v-html="text"></p>
                </div>
              </div>
            </div>
            <div class="modal-btn">
              <div class="btn-wrap">
                <button class="btn yd-cta yd-cta--primary" @click="confirm">
                  {{ confirmText }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, getCurrentInstance, toRefs } from 'vue';
const { data } = defineProps(['data']);
const emits = defineEmits(['close']);
const { title = '', text = '', confirmText = '' } = toRefs(data);

const { confirmCallback } = data;
const confirm = () => {
  if (confirmCallback) confirmCallback();
  emits('close');
};
</script>

<style scoped></style>
